import { useState, useContext } from "react";
import { FiHelpCircle } from "react-icons/fi";
import { BaseContext } from "../../../../contexts/BaseContext";
import { GraphContext } from "../../../../contexts/GraphContext";
import { BaseJobCard } from "./BaseJobCard";
import { JOB_REGISTRY } from "./JobRegistry";

// Generic Job component that uses the registry configuration
export const GenericJob = ({ job, onJobChange }) => {
  const contextValues = useContext(BaseContext);
  const graphContext = useContext(GraphContext);

  // Get the job configuration from registry
  const jobConfig = JOB_REGISTRY[job.endpoint];

  // Initialize the state with values from job
  const initialValues = jobConfig?.getInitialValues(job.endpoint_request_body);
  const [fieldValues, setFieldValues] = useState(initialValues);

  if (!jobConfig) {
    return (
      <div className="bg-white rounded-xl shadow-md p-6 border border-gray-200 hover:border-primary/40 hover:shadow-lg transition-all duration-300">
        <div className="flex justify-between items-center mb-5">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-gray-100 rounded-lg text-gray-500">
              <FiHelpCircle className="w-5 h-5" />
            </div>
            <h3 className="text-xl font-bold text-gray-800">
              Unknown Job Type
            </h3>
          </div>
          <div className="px-4 py-1.5 rounded-full text-sm font-semibold tracking-wide bg-gray-100 text-gray-700 border border-gray-200 flex items-center shadow-sm">
            {job.endpoint}
          </div>
        </div>
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <p className="text-gray-600">
            This job type is not supported by the current UI version.
          </p>
        </div>
      </div>
    );
  }

  // Enhance job with context values for field rendering
  const enhancedJob = {
    ...job,
    context: {
      ...contextValues,
      ...graphContext,
    },
  };

  return (
    <BaseJobCard
      job={enhancedJob}
      onJobChange={onJobChange}
      title={jobConfig.title}
      icon={jobConfig.icon}
      fields={jobConfig.fields}
      fieldValues={fieldValues}
      setFieldValues={setFieldValues}
    >
      {jobConfig.renderAdditional &&
        jobConfig.renderAdditional({
          fieldValues,
          setFieldValues,
          isDisabled: job.status === "in_progress",
          job: enhancedJob,
        })}
    </BaseJobCard>
  );
};

export const WorkflowJobs = ({ jobs, onJobChange }) => {
  // Handle changes to a specific job
  const handleJobChange = (updatedJob, index) => {
    if (onJobChange) {
      onJobChange(updatedJob, index);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      {jobs.map((job, index) => (
        <GenericJob
          key={job.id || index}
          job={job}
          onJobChange={(updatedJob) => handleJobChange(updatedJob, index)}
        />
      ))}
    </div>
  );
};
